<template>
  <Layout>
    <div class="case-content">
      <!-- 客户案例 -->
      <div class="customer-case">
        <div
          class="bg-img"
          :style="{
            'background-image': `url(${require(`@/assets/images/customerCase/customerCase1.jpg`)})`,
          }"
        >
          <!-- <img src="@/assets/images/customerCase/customerCase1.jpg" alt="" class="img-customer-case"> -->
        </div>
        <div class="container">
          <!-- 导航切换区 -->
          <div class="nav-wraper">
            <div class="nav">
              <div
                class="item"
                @click="handleTabClick(index, $event)"
                :class="{ 'active-style': actvieIndex === index }"
                v-for="(item, index) in navList"
                :key="index"
              >
                <div class="item-text">{{ item.text }}</div>
                <div v-show="actvieIndex === index" class="triangle"></div>
              </div>
            </div>
          </div>
          <!-- 切换区的内容 -->

          <div v-for="(list, index) in dataList" :key="index">
            <div class="content-list" v-show="actvieIndex === index">
              <div class="introduction">
                <div>
                  <div class="title">{{ list.title }}</div>
                  <div class="text">
                    {{ list.content }}
                  </div>
                </div>
                <div class="img-bottom">
                  <img :src="list.casesBg" alt="" class="logo-icon" />
                </div>
              </div>
              <!-- 背景图和logo -->
              <div class="layer">
                <img
                  :src="require('@/assets/images/customerCase/circle.png')"
                  alt=""
                  class="circle-bg"
                />
                <div class="circle-icon">
                  <img :src="list.Logo" alt="" class="img" />
                </div>
                <div
                  class="circle-wrapper"
                  :class="{
                    'case-en': $i18n.locale === 'en_US',
                    'case-ja': $i18n.locale === 'ja_JP',
                  }"
                >
                  <div class="circle circle1">{{ list.title1 }}</div>
                  <div class="circle circle2">{{ list.title2 }}</div>
                  <div class="circle circle3">{{ list.title3 }}</div>
                </div>
              </div>

              <!-- 右边三块内容 -->
              <div class="right">
                <div class="item1">
                  <div class="item-title">{{ list.title1 }}</div>
                  <div
                    class="item-content"
                    v-html="formattedText(list.content1)"
                  ></div>
                </div>
                <div class="item2">
                  <div class="item-title">{{ list.title2 }}</div>
                  <div
                    class="item-content"
                    v-html="formattedText(list.content2)"
                  ></div>
                </div>
                <div class="item3">
                  <div class="item-title">{{ list.title3 }}</div>
                  <div
                    class="item-content"
                    v-html="formattedText(list.content3)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 品牌案例 -->
      <section class="rn-section-gap" :class="{ en: $i18n.locale === 'en_US' }">
        <!-- <div>{{}}</div> -->
        <div class="container">
          <SectionTitle
            :title="$t('cases.brand_cases.title')"
            :sectionTitleStyle="1"
            textAlign="center"
            :description="$t('cases.brand_cases.subtitle')"
          />
          <Brand :brandList="brandList" brandFrom="cases" :brandStyle="1" />
          <div
            v-if="showLoadMore"
            class="d-flex mt--30 justify-content-center align-items-center"
          >
            <a href="javascript:;" @click="loadmore" class="vyung-button">{{
              $t("home.more")
            }}</a>
          </div>
        </div>
      </section>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../components/common/Layout";
import Separator from "../../components/elements/separator/Separator";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import Brand from "@/components/elements/brand/Brand";
import { casesList } from "@/helpers/api";
export default {
  name: "CustomerCase",
  components: { Layout, Brand, Separator, SectionTitle },
  data() {
    return {
      navList: [
        { id: "001", text: this.$t("cases.tab.company1") },
        { id: "002", text: this.$t("cases.tab.company2") },
        { id: "003", text: this.$t("cases.tab.company3") },
        { id: "004", text: this.$t("cases.tab.company4") },
        { id: "005", text: this.$t("cases.tab.company5") },
      ],
      dataList: [
        {
          id: "001",
          title: this.$t("cases.tab.title"),
          content: this.$t("cases.tab.tab01.content"),
          Logo: require("../../assets/images/customerCase/cases01.png"),
          jahwaImg: require("../../assets/images/customerCase/jahwa.png"),
          casesBg: require("@/assets/images/customerCase/cases01-bg.jpg"),
          title1: this.$t("cases.tab.title1"),
          content1: this.$t("cases.tab.tab01.content1"),
          title2: this.$t("cases.tab.title2"),
          content2: this.$t("cases.tab.tab01.content2"),
          title3: this.$t("cases.tab.title3"),
          content3: this.$t("cases.tab.tab01.content3"),
        },
        {
          id: "002",
          title: this.$t("cases.tab.title"),
          content: this.$t("cases.tab.tab02.content"),
          Logo: require("../../assets/images/customerCase/cases02.png"),
          jahwaImg: require("../../assets/images/customerCase/jahwa.png"),
          casesBg: require("@/assets/images/customerCase/cases02-bg.jpg"),
          title1: this.$t("cases.tab.title1"),
          content1: this.$t("cases.tab.tab02.content1"),
          title2: this.$t("cases.tab.title2"),
          content2: this.$t("cases.tab.tab02.content2"),
          title3: this.$t("cases.tab.title3"),
          content3: this.$t("cases.tab.tab02.content3"),
        },
        {
          id: "003",
          title: this.$t("cases.tab.title"),
          content: this.$t("cases.tab.tab03.content"),
          Logo: require("../../assets/images/customerCase/cases03.png"),
          jahwaImg: require("../../assets/images/customerCase/jahwa.png"),
          casesBg: require("@/assets/images/customerCase/cases03-bg.png"),
          title1: this.$t("cases.tab.title1"),
          content1: this.$t("cases.tab.tab03.content1"),
          title2: this.$t("cases.tab.title2"),
          content2: this.$t("cases.tab.tab03.content2"),
          title3: this.$t("cases.tab.title3"),
          content3: this.$t("cases.tab.tab03.content3"),
        },
        {
          id: "004",
          title: this.$t("cases.tab.title"),
          content: this.$t("cases.tab.tab04.content"),
          Logo: require("../../assets/images/customerCase/cases04.png"),
          jahwaImg: require("../../assets/images/customerCase/jahwa.png"),
          casesBg: require("@/assets/images/customerCase/cases04-bg.png"),
          title1: this.$t("cases.tab.title1"),
          content1: this.$t("cases.tab.tab04.content1"),
          title2: this.$t("cases.tab.title2"),
          content2: this.$t("cases.tab.tab04.content2"),
          title3: this.$t("cases.tab.title3"),
          content3: this.$t("cases.tab.tab04.content3"),
        },
        {
          id: "005",
          title: this.$t("cases.tab.title"),
          content: this.$t("cases.tab.tab05.content"),
          Logo: require("../../assets/images/customerCase/cases05.jpg"),
          jahwaImg: require("../../assets/images/customerCase/jahwa.png"),
          casesBg: require("@/assets/images/customerCase/cases05-bg.jpg"),
          title1: this.$t("cases.tab.title1"),
          content1: this.$t("cases.tab.tab05.content1"),
          title2: this.$t("cases.tab.title2"),
          content2: this.$t("cases.tab.tab05.content2"),
          title3: this.$t("cases.tab.title3"),
          content3: this.$t("cases.tab.tab05.content3"),
        },
      ],
      caseList: [],
      actvieIndex: 0,

      brandList: [],
      PageIndex: 1,
      showLoadMore: true,
    };
  },
  created() {
    this.getCaseList("refresh");
  },
  methods: {
    // 获取品牌列表
    getCaseList(type) {
      casesList(`PageIndex=${this.PageIndex}&PageSize=20`).then((res) => {
        if (res.state == "success") {
          if (type === "loadmore") {
            this.brandList = this.brandList.concat(res.data.rows);
            if (this.brandList.length >= res.data.totalCount) {
              this.showLoadMore = false;
            }
          } else {
            this.brandList = res.data.rows;
          }
        }
      });
    },
    formattedText(text) {
      // replace(/•(?!$)/g, '<br>•')
      return text.replace(/#/g, "<br>");
    },
    loadmore() {
      let list = [];
      this.PageIndex += 1;
      this.getCaseList("loadmore");
    },
    handleTabClick(index, event) {
      this.actvieIndex = index;
      if (event && event.currentTarget) {
        const item = event.currentTarget;
        const wrapper = item.closest(".nav-wraper");
        if (wrapper) {
          const wrapperWidth = wrapper.clientWidth;
          const itemWidth = item.clientWidth;
          const itemLeft = item.offsetLeft;
          const scrollLeft = itemLeft - (wrapperWidth - itemWidth) / 2;
          wrapper.scrollTo({
            left: scrollLeft,
            behavior: "smooth",
          });
        }
      }
    },
  },
};
</script>
